/* src/app/expenses/features/expense-list/expense-list-feature.component.scss */
:host ::ng-deep .tabulator {
  overflow: auto !important;
}
/*# sourceMappingURL=expense-list-feature.component.css.map */
